import { render, staticRenderFns } from "./BracketsEmpty.vue?vue&type=template&id=084e46d2"
import script from "./BracketsEmpty.vue?vue&type=script&lang=js"
export * from "./BracketsEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports